/**
 * Berndorf — Detail-Tabs der Produktseite.
 *
 * Reine Umschaltung, kein Nachladen: alle Panels stehen im Markup, weil ihre
 * Inhalte aus Metafeldern kommen und ohnehin gerendert sind. Damit bleibt der
 * Text auch ohne JavaScript lesbar — dann sind schlicht alle Panels sichtbar.
 *
 * Tastatur nach WAI-ARIA Tabs: Pfeiltasten wechseln, Home/End springen.
 */
(function () {
  'use strict';

  function tabsIn(root) {
    return Array.prototype.slice.call(root.querySelectorAll('[data-berndorf-tab]'));
  }

  function panelsIn(root) {
    return Array.prototype.slice.call(root.querySelectorAll('[data-berndorf-tabpanel]'));
  }

  function select(root, tab) {
    var tabs = tabsIn(root);
    var panels = panelsIn(root);
    var index = tabs.indexOf(tab);
    if (index === -1) return;

    tabs.forEach(function (item, i) {
      var isActive = i === index;
      item.classList.toggle('is-active', isActive);
      item.setAttribute('aria-selected', isActive ? 'true' : 'false');
      item.setAttribute('tabindex', isActive ? '0' : '-1');
    });

    panels.forEach(function (panel, i) {
      var isActive = i === index;
      panel.hidden = !isActive;
      panel.classList.toggle('is-hidden', !isActive);
    });
  }

  document.addEventListener('click', function (event) {
    var tab = event.target.closest('[data-berndorf-tab]');
    if (!tab) return;

    var root = tab.closest('[data-berndorf-tabs]');
    if (root) select(root, tab);
  });

  document.addEventListener('keydown', function (event) {
    var tab = event.target.closest('[data-berndorf-tab]');
    if (!tab) return;

    var root = tab.closest('[data-berndorf-tabs]');
    if (!root) return;

    var tabs = tabsIn(root);
    var index = tabs.indexOf(tab);
    var next = null;

    if (event.key === 'ArrowRight') next = tabs[(index + 1) % tabs.length];
    if (event.key === 'ArrowLeft') next = tabs[(index - 1 + tabs.length) % tabs.length];
    if (event.key === 'Home') next = tabs[0];
    if (event.key === 'End') next = tabs[tabs.length - 1];
    if (!next) return;

    event.preventDefault();
    select(root, next);
    next.focus();
  });

  /* Startzustand: der erste Tab ist fokussierbar, die übrigen nicht — sonst
     tabbt man sich durch alle Reiter statt in den Inhalt.

     Klick und Tastatur laufen über Delegation am document und überleben einen
     DOM-Austausch. Dieses `tabindex` nicht: es wird im Liquid nicht gerendert,
     sondern hier gesetzt. Nach einem Section-Rerender (Ausführung-Umschalter)
     kämen sonst frische Reiter ohne `tabindex` zurück — alle tabbbar, das
     Roving-Tabindex-Muster wäre kaputt. Deshalb als Funktion, die auch auf
     `berndorf:section-replaced` erneut läuft. */
  function initTabindex(scope) {
    (scope || document).querySelectorAll('[data-berndorf-tabs]').forEach(function (root) {
      tabsIn(root).forEach(function (tab, i) {
        tab.setAttribute('tabindex', i === 0 ? '0' : '-1');
      });
    });
  }

  initTabindex();
  document.addEventListener('berndorf:section-replaced', function (event) {
    initTabindex(event.detail && event.detail.section);
  });
})();
